import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChefHat } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, Loader, EmptyState, Badge, DemoTag, fcTone } from "@/components/kit";

export default function Recipes() {
  const nav = useNavigate();
  const [recipes, setRecipes] = useState(null);
  useEffect(() => { api.get("/recipes").then(({ data }) => setRecipes(data.recipes || [])).catch(() => setRecipes([])); }, []);
  if (!recipes) return <Loader />;
  return (
    <div>
      <PageHeader eyebrow="Library" title="Recipes" subtitle="Every dish across all your menus." />
      {recipes.length === 0 ? <EmptyState icon={ChefHat} title="No recipes yet" body="Generate a menu to build your recipe library." /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 stagger">
          {recipes.map((r, i) => (
            <button key={i} onClick={() => nav(`/menus/${r.menu_id}`)} data-testid={`recipe-card-${i}`} className="matte-card overflow-hidden text-left group">
              <div className="h-40 bg-black/50 relative overflow-hidden">
                {r.plating_image ? <img src={r.plating_image} alt={r.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  : <div className="w-full h-full flex items-center justify-center text-white/20"><ChefHat size={32} /></div>}
                <div className="absolute top-2 right-2">{r.demo && <DemoTag />}</div>
              </div>
              <div className="p-4">
                <p className="label-eyebrow">{r.course}</p>
                <h3 className="font-serif text-lg leading-tight mt-1 group-hover:gold-text transition-colors">{r.name}</h3>
                <div className="flex items-center justify-between mt-3">
                  <Badge tone={fcTone(r.food_cost_pct)}>{r.food_cost_pct}%</Badge>
                  <span className="font-mono text-white/50 text-sm">${r.cost}</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
